// extracted by mini-css-extract-plugin
export default {"input":"ItemChooserSearch_input__MEmOR"};